module.exports = __webpack_public_path__ + "static/assets/5d89e6b41c16ef420f51c786baba05ff.png";